// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f9040ac8","453":"5b620e41","732":"62ed2103","977":"4e3651cf"}[chunkId] + ".chunk.js";
};